import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

/**
 * Announces route changes to screen readers using a visually hidden live region.
 * Place this component inside <BrowserRouter> so useLocation() works.
 */
export default function RouteAnnouncer() {
  const location = useLocation();
  const [announcement, setAnnouncement] = useState("");

  useEffect(() => {
    const path = location.pathname;
    const pageName =
      path === "/"
        ? "Home"
        : path
            .split("/")
            .filter(Boolean)
            .map((segment) =>
              segment
                .replace(/-/g, " ")
                .replace(/\b\w/g, (c) => c.toUpperCase())
            )
            .join(" – ");

    setAnnouncement(`Navigated to ${pageName}`);
  }, [location.pathname]);

  return (
    <div
      role="status"
      aria-live="polite"
      aria-atomic="true"
      className="sr-only"
    >
      {announcement}
    </div>
  );
}
